import { Alert, Drawer } from 'antd';
import { useNavigate } from 'react-router';
import { FormCardSkeleton } from '../../../../../shared/components/FormCardSkeleton';
import { gpsIntegrationTabPath } from '../gps.paths';
import type { AdapterCatalogueState } from '../hooks/use-adapter-catalogue';
import { useIntegrationSheet } from '../hooks/use-integration-sheet';
import { IntegrationForm } from './IntegrationForm';

interface IntegrationSheetProps {
  catalogue: AdapterCatalogueState;
  adapterKey: string | undefined;
  onClose: () => void;
}

/** Install a GPS adapter: its own fields, a connection test before saving, and write-only secrets. Then its page opens on Devices, to put them on trucks. */
export function IntegrationSheet({ catalogue, adapterKey, onClose }: IntegrationSheetProps) {
  const navigate = useNavigate();
  const sheet = useIntegrationSheet({ catalogue, adapterKey, integration: undefined, onDone: (saved) => navigate(gpsIntegrationTabPath(saved.id, 'devices')) });

  return (
    <Drawer open onClose={onClose} title={`Add ${sheet.adapter?.displayName ?? 'a GPS integration'}`} size={480}>
      {sheet.isLoading && <FormCardSkeleton label="Loading the GPS adapter" />}
      {!sheet.isLoading && !sheet.adapter && (
        <Alert
          type="error"
          showIcon
          title="This GPS adapter isn't available"
          description="It may not be part of this release, or can't be installed on this deployment."
        />
      )}
      {!sheet.isLoading && sheet.adapter && <IntegrationForm sheet={sheet} adapter={sheet.adapter} isEdit={false} />}
    </Drawer>
  );
}
